export function popup() {

    const popupTrigger = $('.nutritionalInfoModal'),
          popup = $('.popup'),
          popupImage = $('.popupImage'),
          popupClose = $('.popup__close'),
          body = $('body');
    
    let imageSrc;

    popupTrigger.on('click', function(e){
        e.preventDefault();
        imageSrc = $(this).attr("data-img");
        popupImage.attr("src", imageSrc);
        popup.addClass('active');
        body.addClass('bodyPopup');
    });

    popupClose.on('click', function () {
        popup.removeClass('active');
        body.removeClass('bodyPopup');
    });
}
